export default "__VITE_ASSET__Il3D0Srk__"